import { render } from "./CategoryTagNewModalPopup.vue?vue&type=template&id=52808225&scoped=true"
import script from "./CategoryTagNewModalPopup.vue?vue&type=script&lang=js"
export * from "./CategoryTagNewModalPopup.vue?vue&type=script&lang=js"

import "./CategoryTagNewModalPopup.vue?vue&type=style&index=0&id=52808225&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52808225"]])

export default __exports__